// extracted by mini-css-extract-plugin
module.exports = {"bigImage":"Home_bigImage__1yqyv","overlay":"Home_overlay__2oKUO","heroText":"Home_heroText__3jajC"};